export const motionTokens = {
  // Duration values in seconds
  duration: {
    fast: 0.2,
    normal: 0.4,
    slow: 0.6,
    slower: 0.8,
    slowest: 1.0,
  },
  
  // Easing functions (Framer Motion array format)
  ease: {
    default: [0.25, 0.46, 0.45, 0.94],  // ease-out
    in: [0.42, 0, 1, 1],                // ease-in
    out: [0, 0, 0.58, 1],               // ease-out
    inOut: [0.42, 0, 0.58, 1],          // ease-in-out
    custom: [0.4, 0, 0.2, 1],           // Material Design
    bounce: [0.68, -0.55, 0.265, 1.55],
    spring: [0.175, 0.885, 0.32, 1.275],
  },

  // Stagger delays for animations
  stagger: {
    fast: 0.05,
    normal: 0.1,
    slow: 0.15,
    slower: 0.2,
  },

  // Common animation distances
  distance: {
    small: 6,
    medium: 12,
    large: 20,
    xlarge: 30,
  },

  // Scale values for hover effects
  scale: {
    subtle: 1.02,
    small: 1.03,
    medium: 1.05,
    large: 1.06,
    xlarge: 1.1,
  },
};